module.exports = __webpack_public_path__ + "static/media/signage.12be1ff2.svg";